// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8f2b2896","187":"9d8380d0","419":"e6ef7a23","563":"12aea644","942":"80d648dc"}[chunkId] + ".chunk.js";
};